import {AnyAction} from 'redux';
import {ThunkAction} from 'redux-thunk';

import {commentFail, commentFetching, commentReceived} from '../../../actions/comments';
import request from '../../../application/api/request';
import selectAlpenroseHost from '../../../entities/pageSetup/apiHosts/selectors/selectAlpenroseHost';
import {CommentObject} from '../../../shapes/comments';
import {State} from '../../../store/initialState';


interface Design {
  id: number;
  name: string;
  user_id: number;
  size: number;
  content_type: string;
  filename: string;
  height: number;
  width: number;
  parent_id?: number;
  thumbnail?: unknown;
  created_at: Date;
  updated_at: Date;
  deleted_at?: Date;
  show_design: boolean;
  fab_of_week_winner: boolean;
  c1: number;
  c2: number;
  c3: number;
  c4: number;
  colorkey: number;
  fabricware_item_id: number;
  description?: string;
  keywords?: unknown;
  for_sale: boolean;
  cat1_id?: number;
  cat2_id?: number;
  shop_preview_style: number;
  at_s3: boolean;
  compressed: boolean;
  spoints: number;
  for_sale_at: Date;
  vector_filename?: string;
  design_right_id?: number;
  partner_id?: number;
  cyan?: unknown;
  magenta?: unknown;
  yellow?: unknown;
  black?: unknown;
  red?: unknown;
  violet?: unknown;
  orange?: unknown;
  gray?: unknown;
  white?: unknown;
  spurrency: number;
  wallpaper_item_id: number;
  decal_item_id?: number;
  for_sale_as_wallpaper: boolean;
  for_sale_as_decal: boolean;
  for_sale_as_fabric: boolean;
  short_description: string;
  gift_wrap_item_id: number;
  for_sale_as_gift_wrap: boolean;
  possible_colors: string;
  app_id: number;
  slug?: unknown;
  image_updated_at: Date;
  image_version: number;
  revision: number;
  etag: string;
}

export interface fetchCommentsResponse {
  data: {
    design: Design;
    comments: CommentObject[];
  };
}

export default function fetchComments(): ThunkAction<Promise<void | fetchCommentsResponse>, State, unknown, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();
    const designId = state.design.id;

    dispatch(commentFetching());

    return request<fetchCommentsResponse>(state, {
      url: `${selectAlpenroseHost(state)}/comments/design/${designId}`
    })
      .then((response) => {
        dispatch(commentReceived(response.data));

        return response.data;
      })
      .catch(() => {
        dispatch(commentFail());
      });
  };
}
